module.exports = __webpack_public_path__ + "static/img/banner.6629125.png";


//////////////////
// WEBPACK FOOTER
// ./static/moblieHome/banner.png
// module id = 6h6E
// module chunks = 1